export class PalletType {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    Inactive: boolean;
}

export default PalletType;